export const baseURL = `${process.env.REACT_APP_EPIC_DEVPORTAL_URL}/api`;

const servicesURL = `${baseURL}/v2/services`;

export const bptServiceURL = `${servicesURL}/bpt`;
